<app-landing-header></app-landing-header>
<section
  class="w-full bg-blue-950 py-6 sm:py-32 bg-[url('/assets/ship.png')] bg-contain bg-right bg-no-repeat"
  id="home"
  data-testid="home-section"
>
  <div
    class="flex flex-col sm:flex-row justify-start items-center w-full max-w-7xl mx-auto text-3xl p-4 sm:pt-4 h-full"
  >
    <div class="flex flex-col justify-center items-start w-full sm:w-3/4">
      <h1
        data-testid="home-header"
        class="text-3xl font-bold sm:text-6xl w-full text-white text-left"
      >
        Inovação em sistemas de navegação
      </h1>
      <p data-testid="home-description" class="text-lg sm:text-lg text-slate-300 text-left mt-8">
        Comprometimento com a excelência em desenvolvimento de equipamentos e sistemas para
        embarcações no Brasil e no Mundo. Tecnologia e precisão a serviço da segurança da navegação.
      </p>
      <div class="flex flex-col sm:flex-row justify-between items-center w-full h-full mt-8">
        <div class="flex flex-col items-start w-full sm:h-40 sm:pr-2">
          <h2 class="text-sm sm:text-xl text-white text-left">
            <span class="border-b-2 border-yellow-300 pb-1">Tecnologia</span> Nacional
          </h2>
          <p class="text-sm sm:text-base text-slate-300 text-left mt-2 w-full">
            Desenvolvida e testada em diversos portos brasileiros
          </p>
        </div>
        <div class="flex flex-col items-start w-full sm:h-40 sm:pr-2">
          <h2 class="text-sm sm:text-xl text-white text-left">
            <span class="border-b-2 border-yellow-300 pb-1">Soluções</span> Customizadas
          </h2>
          <p class="text-sm sm:text-base text-slate-300 text-left mt-2 w-full">
            Atendendo necessidades locais específicas
          </p>
        </div>
        <div class="flex flex-col items-start w-full sm:h-40 sm:pr-2">
          <h2 class="text-sm sm:text-xl text-white text-left">
            <span class="border-b-2 border-yellow-300 pb-1">Parcerias</span> Estratégicas
          </h2>
          <p class="text-sm sm:text-base text-slate-300 text-left mt-2 w-full">
            Cooperação técnica com universidades, centros de pesquisa e entidades setoriais
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="w-full bg-white py-6 sm:py-24" id="about" data-testid="about-section">
  <div
    class="flex flex-col sm:flex-row justify-center items-center w-full sm:max-w-7xl mx-auto text-3xl p-4 sm:pt-4 h-full"
  >
    <div class="flex flex-col justify-center items-center w-full sm:pr-4">
      <h2 class="text-2xl sm:text-5xl font-bold w-full text-slate-700 text-left">
        Sobre a Navigandi
      </h2>
      <p class="text-lg sm:text-lg text-slate-500 text-left mt-4 sm:mt-8">
        Fundada em 2019 por pesquisadores oriundos do Tanque de Provas Numérico (TPN) da
        Universidade de São Paulo, a Navigandi é uma Startup de base tecnológica focada no
        desenvolvimento de software, sistemas e produtos de posicionamento e navegação para o uso em
        operações portuárias e offshore. Nossa jornada é pautada pela busca constante de inovação,
        compromisso com a qualidade e uma profunda conexão com as necessidades de nossos parceiros.
      </p>
    </div>

    <div class="flex flex-row justify-center items-center w-full mt-4 sm:mt-0">
      <img
        src="assets/sobre.jpg"
        alt="Logo da empresa"
        class="w-full h-auto shadow-sm rounded-lg"
      />
    </div>
  </div>
</section>
<section class="w-full bg-slate-50 py-6 sm:py-24" id="services" data-testid="services-section">
  <div
    class="flex flex-col justify-center items-center w-full sm:max-w-7xl mx-auto text-3xl p-4 sm:pt-4 h-full"
  >
    <h2 class="text-2xl sm:text-5xl font-bold w-full text-slate-700 text-center">
      Nossos serviços
    </h2>
    <p class="text-lg xl:w-1/2 sm:text-xl text-slate-500 sm:text-center mt-4 sm:mt-8">
      Da consultoria ao desenvolvimento de software, a Navigandi está comprometida em atender suas
      necessidades específicas no controle e monitoramento de embarcações
    </p>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 w-full sm:p-4 mt-6 sm:mt-24">
      <div>
        <div class="flex flex-row items-center">
          <i class="fa-solid fa-mobile-screen-button text-slate-500 text-2xl"></i>
          <h3 class="text-xl w-full text-slate-700 text-left ml-2">
            <span class="border-b-2 border-yellow-300 pb-1">Software</span> Customizado
          </h3>
        </div>
        <p class="text-base text-slate-500 text-left mt-4">
          Desenvolvemos programas de navegação e monitoramento sob medida para suas necessidades.
        </p>
      </div>
      <div>
        <div class="flex flex-row items-center">
          <i class="fa-solid fa-water text-slate-500 text-2xl"></i>
          <h3 class="text-xl w-full text-slate-700 text-left ml-2">
            <span class="border-b-2 border-yellow-300 pb-1">Dados</span> Hidrográficos
          </h3>
        </div>
        <p class="text-base text-slate-500 text-left mt-2">
          Tratamento e visualização de informações hidrográficas para softwares de navegação e
          monitoramento.
        </p>
      </div>
      <div>
        <div class="flex flex-row items-center">
          <i class="fa-solid fa-gears text-slate-500 text-2xl"></i>
          <h3 class="text-xl w-full text-slate-700 text-left ml-2">
            <span class="border-b-2 border-yellow-300 pb-1">Aferição</span> de Embarcações
          </h3>
        </div>
        <p class="text-base text-slate-500 text-left mt-2">
          Serviços de medição precisa de movimentos para análise de risco, modelagem e simulação.
        </p>
      </div>

      <div>
        <div class="flex flex-row items-center">
          <i class="fa-solid fa-gauge text-slate-500 text-2xl"></i>
          <h3 class="text-xl w-full text-slate-700 text-left ml-2">
            <span class="border-b-2 border-yellow-300 pb-1">Projetos</span> de Instrumentação
          </h3>
        </div>
        <p class="text-base text-slate-500 text-left mt-2">
          Soluções em instrumentação e controle para projetos especiais.
        </p>
      </div>

      <div>
        <div class="flex flex-row items-center">
          <i class="fa-solid fa-location-arrow text-slate-500 text-2xl"></i>
          <h3 class="text-xl w-full text-slate-700 text-left ml-2">
            <span class="border-b-2 border-yellow-300 pb-1">Sistemas</span> de Navegação
          </h3>
        </div>
        <p class="text-base text-slate-500 text-left mt-2">
          Equipamentos e sistemas especializados para navegação e acompanhamento de operações.
        </p>
      </div>

      <div>
        <div class="flex flex-row items-center">
          <i class="fa-solid fa-chalkboard-user text-slate-500 text-2xl"></i>
          <h3 class="text-xl w-full text-slate-700 text-left ml-2">
            <span class="border-b-2 border-yellow-300 pb-1">Consultoria</span> e Treinamento
          </h3>
        </div>
        <p class="text-base text-slate-500 text-left mt-2">
          Oferecemos consultoria especializada e treinamento em todas as nossas áreas de atuação.
        </p>
      </div>
    </div>
  </div>
</section>
<section class="w-full" id="products" data-testid="products-section">
  <section
    class="flex flex-col items-center justify-between w-full sm:h-screen py-6 sm:py-24 bg-[url('/assets/signin-background.jpg')] bg-cover bg-center bg-no-repeat bg-blue-200 bg-blend-multiply"
    id=" ORBIS"
  >
    <div
      class="flex flex-col justify-center items-center w-full xl:w-1/2 sm:max-w-7xl mx-auto text-3xl p-4"
    >
      <h2 class="text-2xl sm:text-5xl font-bold w-full text-white text-center">Produtos</h2>
      <p class="text-lg sm:text-xl w-full text-slate-100 text-center mt-8">
        A Navigandi oferece uma variedade de soluções para tornar suas operações de navegação mais
        seguras e eficientes.
      </p>
    </div>

    <div class="flex flex-col justify-center items-center w-full h-full">
      <div
        class="flex flex-col sm:flex-row justify-start sm:justify-end items-center w-full sm:max-w-7xl mx-auto text-3xl p-4 sm:pt-4 h-full"
      >
        <div
          class="flex flex-col justify-center items-start w-full sm:w-1/2 p-8 sm:mr-4 bg-slate-50 rounded shadow"
        >
          <h2 class="text-xl font-medium sm:text-4xl w-full text-slate-900 text-left">ORBIS®</h2>
          <p class="text-lg sm:text-base text-slate-900 text-left sm:mt-4">
            O PPU mais leve e preciso da categoria
          </p>
          <p class="text-lg sm:text-base text-slate-500 text-left sm:mt-4">
            O Navigandi Orbis redefine os padrões de PPU com sua precisão inigualável e design
            ergonômico. Desenvolvido e testado em colaboração com a praticagem brasileira, o Orbis é
            a escolha confiável para manobras seguras e eficientes.
          </p>
          <button
            (click)="openProductInfoDialog()"
            class="flex flex-row items-center bg-yellow-500 hover:bg-yellow-700 text-white text-base font-bold py-2 px-4 rounded-full shadow mt-4"
          >
            <i class="fa-solid fa-info mr-2"></i>
            Saiba mais
          </button>
        </div>
      </div>
    </div>
  </section>

  <section
    class="flex flex-col items-center justify-between w-full sm:h-screen py-6 sm:py-24 bg-slate-50"
  >
    <div
      class="flex flex-col justify-center items-center w-full xl:w-1/2 sm:max-w-7xl mx-auto text-3xl p-4"
    >
      <h2 class="text-2xl sm:text-5xl font-bold w-full text-slate-700 text-center">
        Outros produtos
      </h2>
      <p class="text-lg sm:text-xl w-full text-slate-500 text-center mt-8">
        A Navigandi oferece uma variedade de soluções para tornar suas operações de navegação mais
        seguras e eficientes.
      </p>
    </div>
    <div
      class="flex flex-col sm:flex-row justify-center items-center w-full sm:max-w-7xl mx-auto text-3xl p-4 h-full"
    >
      <div
        class="flex flex-col justify-start max-w-sm min-h-96 rounded overflow-hidden shadow-lg mx-4 bg-white"
      >
        <div class="w-full">
          <img class="w-full object-fill" src="assets/navicombo.png" alt="NaviCombo" />
        </div>
        <div class="px-6 py-4 sm:min-h-36 flex-grow">
          <div class="font-bold text-xl mb-2">NaviCombo</div>
          <p class="text-slate-700 text-base">Sistema de Navegação para Comboios.</p>
        </div>
      </div>
      <div
        class="flex flex-col justify-start max-w-sm min-h-96 rounded overflow-hidden shadow-lg mx-4 mt-4 sm:mt-0 bg-white"
      >
        <div class="w-full">
          <img class="w-full object-fill" src="assets/navipilot.png" alt="NavigandiPilot" />
        </div>
        <div class="px-6 py-4 sm:min-h-36 flex-grow">
          <div class="font-bold text-xl mb-2">Navigandi Pilot</div>
          <p class="text-slate-700 text-base">
            Consciência situacional aumentada para manobras mais seguras e eficazes.
          </p>
        </div>
      </div>

      <div
        class="flex flex-col justify-start max-w-sm min-h-96 rounded overflow-hidden shadow-lg mx-4 mt-4 sm:mt-0 bg-white"
      >
        <div class="w-full">
          <img class="w-full object-fill" src="assets/soluções.jpg" alt="NaviCombo" />
        </div>
        <div class="px-6 py-4 sm:min-h-36 flex-grow">
          <div class="font-bold text-xl mb-2">Soluções únicas</div>
          <p class="text-slate-700 text-base">
            Serviços personalizados para atender às suas necessidades específicas.
          </p>
        </div>
      </div>
    </div>
  </section>
</section>

<section
  class="flex flex-col items-center justify-between w-full py-6 sm:py-24 bg-white"
  data-testid="collaborations-section"
>
  <div class="flex flex-col justify-center items-center w-full sm:max-w-7xl mx-auto text-3xl p-4">
    <div
      class="flex flex-col justify-center items-center w-full xl:w-1/2 sm:max-w-7xl mx-auto text-3xl p-4"
    >
      <h2 class="text-2xl sm:text-5xl font-bold w-full text-slate-700 text-center">
        Colaborações de Sucesso
      </h2>
    </div>

    <div class="flex w-full justify-center items-center mt-6 sm:mt-24">
      <gallery
        [items]="imagesCarrousel"
        [loop]="true"
        [thumbs]="false"
        [visibleItems]="5"
        [counter]="false"
        [objectFit]="'contain'"
        class="w-full h-20 rounded-2xl"
      >
      </gallery>
    </div>
  </div>
</section>

<section class="w-full bg-blue-900 py-6 sm:py-24" id="contact" data-testid="contact-section">
  <div
    class="flex flex-col sm:flex-row justify-center items-center w-full sm:max-w-7xl mx-auto text-3xl p-4 sm:pt-4 h-full"
  >
    <div class="flex flex-col justify-center items-center w-full">
      <h2 class="text-2xl sm:text-5xl font-bold text-white sm:max-w-7xl mx-auto text-center">
        Solicite uma demonstração
      </h2>
      <p class="text-lg sm:text-xl text-slate-300 text-center mt-2 sm:mt-4">
        Nossos especialistas irão lhe apresentar os benefícios e vantagens dos produtos Navigandi
      </p>
      <a
        href="mailto:contato@navigandi.com.br"
        class="bg-blue-500 hover:bg-blue-600 text-white text-lg font-bold py-4 px-8 rounded mt-4 sm:mt-8"
        >Tenho interesse</a
      >
    </div>
  </div>
</section>

<app-landing-footer></app-landing-footer>
